module.exports = "//static.hsappstatic.net/ContentComponents/static-2.68361/img/website-page-zero.svg"